module.exports = __webpack_public_path__ + "static/fonts/roboto-regular-webfont.166faf4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-regular-webfont.woff2
// module id = 1664
// module chunks = 28